const isObject = (val: any) =>
  Object.prototype.toString.call(val) === "[object Object]";

export default isObject;
